var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnArrowClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 6,
    viewBox: "0 0 16 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.48574 5.55791L15.57 1.12017C15.8512 0.915227 16 0.708732 16 0.537094C16 0.205266 15.4667 0 14.5739 0L1.42403 0C0.53231 0 0 0.205008 0 0.53606C0 0.707956 0.148943 0.911153 0.430899 1.11655L6.51504 5.55636C6.90695 5.84188 7.43434 6 8.00071 6C8.5667 6.00006 9.09396 5.84375 9.48574 5.55791Z",
    fill: "#1E3799"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnArrowClosed);
export default __webpack_public_path__ + "static/media/icn_arrow-closed.9e959b3e675c18734d2705daaacd4fec.svg";
export { ForwardRef as ReactComponent };